module.exports = __webpack_public_path__ + "media/static/icons/icon-tide-needle-befda57c478ab8dfd45b15f399c92515.svg";